<p class="fs-3 my-2 fw-bold">{{ AdaaHelper.getItemValueByToken(mandatoryFields(), "name") }}</p>

<div class="bg-card rounded p-3">
    <div class="row">
        @for (item of mandatoryFields().parameterCatalogs; track $index) {
            <div class="col-6 mb-3 d-flex justify-content-between align-items-center">
                <p>{{ AdaaHelper.getItemValueByToken(item, "name") }}</p>
                <adaa-form-checkbox
                    controlName="mandatory"
                    formControlName="mandatory"
                    checkboxMode="yesNo"
                    [checked]="item.mandatory === AdaaBoolean.Y"
                    [isDisabled]="item.visibleParameter === AdaaBoolean.N"
                    (inputChanges)="toggleMandatory($event, item)"
                />
            </div>
        }
    </div>
</div>

<div class="my-4">
    <adaa-form-action-buttons
        [cancelButtonTitle]="'common.form.button.cancel'"
        [saveButtonTitle]="'common.form.button.submit'"
        [showSaveButton]="true"
        (cancelClicked)="goBack()"
        (saveClicked)="submit()"
    ></adaa-form-action-buttons>
</div>
